import React from 'react';
import { X } from 'lucide-react';

export const Modal = ({ title, onClose, children }) => (
  <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
    <div className="bg-gray-800 rounded-xl w-full max-w-lg shadow-2xl">
      <div className="p-6 border-b border-gray-700 flex justify-between items-center">
        <h3 className="text-lg font-bold text-white">{title}</h3>
        <button onClick={onClose} className="text-gray-400 hover:text-white transition">
          <X size={20} />
        </button>
      </div>
      <div className="p-6">{children}</div>
    </div>
  </div>
);

export const Field = ({ label, children }) => (
  <div>
    <label className="text-gray-400 text-xs mb-1 block">{label}</label>
    {children}
  </div>
);

export const ModalFooter = ({ onCancel, onSave, saving, disabled, label }) => (
  <div className="flex justify-end gap-3 mt-6 pt-4 border-t border-gray-700">
    <button
      onClick={onCancel}
      className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg text-sm transition"
    >
      Cancel
    </button>
    <button
      onClick={onSave}
      disabled={saving || disabled}
      className="px-4 py-2 bg-blue-600 hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed text-white rounded-lg text-sm transition"
    >
      {saving ? 'Saving…' : label}
    </button>
  </div>
);